import { ChangeEvent, useCallback } from "react";

import { sizes } from "../theme";
import { textInputStyles } from "./text-input";

type Props<N extends string> = {
  disabled?: boolean;
  name: N;
  value: Date | null;
  onChange: (name: N, value: Date | null) => void;
};
export function DateInput<N extends string>({
  disabled = false,
  name,
  value,
  onChange,
}: Props<N>) {
  // Handlers
  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const val = e.target.value;
      onChange(name, val ? new Date(val) : null);
    },
    [name, onChange]
  );

  // Render
  return (
    <input
      type="date"
      name={name}
      value={value?.toISOString().slice(0, 10) ?? ""}
      onChange={handleChange}
      disabled={disabled}
      // @ts-ignore
      style={{
        ...textInputStyles.container,
        ...textInputStyles.text,
        ...(disabled ? textInputStyles.disabled : {}),
        padding: `0 ${sizes["6"]}px`,
        fontFamily: "BrandRegular",
        border: "none",
      }}
    />
  );
}
